// extracted by mini-css-extract-plugin
export default {"mainWrapper":"main-wrapper__Svs5EeI0","main":"main__sNo4NCUP"};